import React, { useEffect, useState } from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import InfoCard from './InfoCard';
import Typography from '@material-ui/core/Typography';
import StarsRoundedIcon from '@material-ui/icons/StarsRounded';
import Button from '@material-ui/core/Button';
import Drawer from '@material-ui/core/Drawer';
import useForm from 'react-hook-form';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import AsyncSelect from 'react-select/async-creatable';

import Profile from 'repositories/Profile';

const useStyle = makeStyles(theme => ({
  list: {
    display: 'flex',
    listStyle: 'none',
    flexWrap: 'wrap',
    '& > li': {
      width: '30%',
      display: 'flex',
      margin: theme.spacing(2, 0),
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
    [theme.breakpoints.down('sm')]: {
      margin: 0,
      padding: 0,
      flexDirection: 'column',
    },
  },
  icon: {
    marginRight: theme.spacing(2),
    color: '#27AE60',
  },
  drawer: {
    maxWidth: 400,
    padding: theme.spacing(2),
    paddingTop: theme.spacing(4),
  },
  form: {
    marginBottom: theme.spacing(2),
  },
  headerTxt: {
    marginBottom: theme.spacing(2),
  },
  submitBtn: {
    marginTop: theme.spacing(2),
  },
}));

const promiseOptions = async input => {
  const res = await Profile.getSpecialities(input);
  // console.log(res);
  return res.data.length && res.data.map(item => ({ label: item.name, value: item.name }));
};

export default function Specialities({ data, submitting, onSubmit, onDelete }) {
  const classes = useStyle();
  const { register, handleSubmit, setValue } = useForm();
  const [open, setOpen] = React.useState(false);

  function handleClickOpen() {
    setOpen(true);
  }

  function handleClose() {
    setOpen(false);
  }

  useEffect(() => {
    register({ name: 'name', required: true });
  }, [register]);

  const [speciality, setSpeciality] = useState('');

  const handleSelect = selected => {
    if (selected) {
      setSpeciality(selected);
      setValue('name', selected.value);
    } else {
      setSpeciality('');
      setValue('name', '');
    }
  };

  return (
    <>
      <InfoCard
        title="Specialities"
        rightItem={
          <Button color="primary" onClick={handleClickOpen}>
            Edit
          </Button>
        }
      >
        {data.length ? (
          <ul className={classes.list}>
            {data.map((item, i) => (
              <li key={i}>
                <StarsRoundedIcon className={classes.icon} />
                <Typography variant="body1">{item.name}</Typography>
              </li>
            ))}
          </ul>
        ) : (
          <Typography align="center" variant="body1">
            No Specialities found! Add few now?
          </Typography>
        )}
      </InfoCard>
      <Drawer anchor="right" open={open} onClose={handleClose} classes={{ paper: classes.drawer }}>
        <Typography variant="body1" align="center" gutterBottom className={classes.headerTxt}>
          Add some Specialities for your business!
        </Typography>
        <Typography variant="body2" align="center" gutterBottom className={classes.headerTxt}>
          e.g: Wifi available, Parking available etc.
        </Typography>
        <form onSubmit={handleSubmit(onSubmit)} className={classes.form}>
          <AsyncSelect
            cacheOptions
            defaultOptions
            isClearable
            placeholder="Add Speciality"
            value={speciality}
            onChange={handleSelect}
            loadOptions={promiseOptions}
          />
          <Button
            fullWidth
            variant="contained"
            disabled={submitting || !speciality}
            type="submit"
            color="primary"
            className={classes.submitBtn}
          >
            Add
          </Button>
        </form>
        <List>
          {data.map((item, i) => (
            <ListItem key={item.name}>
              <ListItemIcon>
                <StarsRoundedIcon className={classes.icon} />
              </ListItemIcon>
              <ListItemText primary={item.name} />
              <ListItemSecondaryAction>
                <IconButton onClick={() => onDelete(item.name)} edge="end" aria-label="delete">
                  <DeleteIcon />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
          ))}
        </List>
      </Drawer>
    </>
  );
}
